import { Col, Row } from "antd";
import { useTranslation } from "react-i18next";
import Form from "shared/components/Form";
import FormField from "shared/components/FormField";
import Select from "shared/components/Select";
import { NAME_SPACES } from "shared/locales/constants";
import { SUBSCRIPTION_FORM_KEYS } from "utils/constants";
import { LEGAL_PROTECTION_OPTIONS } from "../../../obseques";

const LegalProtection = ({
  setPercent,
  isFieldRequired,
  initialValues,
  bindField,
}) => {
  const { t } = useTranslation(NAME_SPACES.PRIVATE.BROKER.CONTRACT);
  const SUBSCRIPTION = t("SUBSCRIPTION", { returnObjects: true });
  const path = "project.fields.legalProtectionMeasure";
  const field = bindField(path, {
    label: SUBSCRIPTION.FORM.LEGAL_PROTECTION.LABEL,
    required: isFieldRequired(path),
    onChange: () => setPercent(initialValues),
  });

  return (
    <div
      className="subscription-form--wrapper"
      id={`${SUBSCRIPTION_FORM_KEYS.ADDITIONAL_INFORMATION.LEGAL_PROTECTION}-section`}
    >
      <Form
        type="vertical"
        title={SUBSCRIPTION.FORM.LEGAL_PROTECTION.TITLE}
        subtitle={SUBSCRIPTION.FORM.LEGAL_PROTECTION.SUBTITLE}
      >
        <Row gutter={[16, 16]}>
          <Col lg={24} xs={24}>
            <FormField
              path={field.path}
              label={field.label}
              required={field.required}
              disabled={field.disabled}
            >
              {(inputField) => (
                <Select
                  type="simple"
                  options={LEGAL_PROTECTION_OPTIONS}
                  label={field.label}
                  placeholder={SUBSCRIPTION.FORM.LEGAL_PROTECTION.PLACEHOLDER}
                  defaultValue={field.defaultValue}
                  {...inputField}
                  onChange={field.onChange}
                  onBlur={field.onBlur}
                />
              )}
            </FormField>
          </Col>
        </Row>
      </Form>
    </div>
  );
};

export default LegalProtection;
